import styled from 'styled-components';
import COLORS from 'shared/constants/colors';
import { Link as ReactRouterLink } from 'react-router-dom';

const Container = styled.div`
  border-top: 1px solid #f3f3f3;
  padding: 52px 15px;
  font-size: 0.95em;
  background-color: #fff;
  background-image: url('https://bigoventees.com/img/chooseUs.png');
  background-size: cover;
  background-repeat: no-repeat;
  color: white;
  font-size: 14px;
`;
const Wrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-gap: 10px;
  justify-content: center;
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;
const NavLinks = styled.div`
  border-bottom: 2px solid #272742;
  @media (min-width: 1024px) {
    border: none;
  }
  a {
    padding: 7.5px 0;
    display: block;
    margin: 0 15px 0 0;
    text-decoration: none;
    color: #fff;
    text-transform: uppercase;
    transition: all ease-out 0.25s;
    font-weight: 700;
    letter-spacing: 1px;
    font-size: 15px;
    line-height: 22px;
    cursor: pointer;
    @media (max-width: 767px) {
      font-size: 13px;
      padding: 5.5px 0;
    }
    &:hover {
      color: ${COLORS.WHITE};
    }
  }
`;

const Link = styled(ReactRouterLink)`
  padding: 7.5px 0;
  display: block;
  margin: 0 15px 0 0;
  text-decoration: none;
  color: #fff;
  text-transform: uppercase;
  transition: all ease-out 0.25s;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 15px;
  line-height: 22px;
  cursor: pointer;
  @media (max-width: 767px) {
    font-size: 13px;
    padding: 5.5px 0;
  }
  &:hover {
    color: ${COLORS.WHITE};
  }
`;
const ContactInfo = styled.div`
  border-bottom: 2px solid #272742;
  @media (min-width: 1024px) {
    border: none;
  }
  > div {
    font-size: 1.2em;
    font-weight: 700;
    color: #fff;
    display: grid;
    grid-column-gap: 20px;
    justify-items: center;
    text-align: center;
    align-items: flex-start;
    margin-top: 15px;
    @media (min-width: 1024px) {
      grid-template-columns: 0.5fr 1fr;
      justify-items: start;
      text-align: left;
      margin-top: 0;
    }
    p {
      margin-top: 0;
      font-size: 19px;
      @media (max-width: 767px) {
        font-size: 16px;
        margin-bottom: 6px;
      }
    }
  }
`;
const SocialLinks = styled.div``;

const LinkBtn = styled.a`
  border-radius: 4px;
  color: ${COLORS.WHITE};
  display: inline-flex;
  align-items: center;
  padding-right: 0.5rem;
  box-shadow: 0 2px 5px 0 rgba(34, 34, 34, 0.5);
  padding: 0;
  margin-bottom: 20px;
  &:hover {
    svg {
      background: #fff;
      color: #000;
      transform: scale(1.2);
      border-radius: 4px;
    }
  }
  svg {
    padding: 0 5px;
    background: ${COLORS.BLACK};
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    transition: all ease-out 0.25s;
    font-size: 38px;
    @media (max-width: 767px) {
      font-size: 34px;
    }
  }
  span {
    padding: 7px 15px;
    background: #000;
    font-size: 20px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    @media (max-width: 767px) {
      font-size: 16px;
    }
  }
`;
const Address = styled.div`
  > div {
    margin-bottom: 30px;
  }
  p {
    margin-top: 0;
    margin-bottom: 5px;
  }
  img {
    width: 25px;
  }
`;

const FooterLogo = styled.div`
  max-width: 250px;
  margin: 0 auto;
  width: 100%;
  img {
    width: 100%;
  }
`;
const Icon = styled.div`
  width: 190px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  svg {
    color: ${COLORS.WHITE};
    transition: all ease-out 0.5s;
    border-radius: 6px;
  }
`;
const Terms = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  width: 100%;
  p {
    font-size: 15px;
    color: #fff;
    font-weight: bold;
    line-height: 22px;
    @media (min-width: 1024px) {
      margin-top: 15px;
      text-align: center;
    }
    @media (max-width: 767px) {
      font-size: 12px;
      text-align: center;
    }
  }
  span {
    cursor: pointer;
    text-decoration: underline;
    :hover {
      color: #fff;
    }
  }
`;
export {
  Container,
  NavLinks,
  Link,
  ContactInfo,
  SocialLinks,
  Wrapper,
  LinkBtn,
  Address,
  FooterLogo,
  Icon,
  Terms,
};
